import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { AgGridLoadingOverlayComponent } from '../../Common/AgGrid/agGridLoadingOverlay.component';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { GetLogFilesComponent } from '../Get-Log-Files/getLogFiles.component';
import { GetLogFilesRepository } from '../Get-Log-Files/getLogFiles.repository';
import { GetLogFileService } from '../Get-Log-Files/getLogFile.service';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule

    ],
    declarations: [
        GetLogFilesComponent
    ],
    providers: [
        GetLogFilesRepository,
        GetLogFileService
    ],
    exports: []
})
export class GetLogFilesModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('getLogFiles', GetLogFilesComponent);
    }
}
